import React, { useEffect, useState } from 'react';
import Main from '../../Main';
import { Col, Dropdown, Row } from 'react-bootstrap';
import columnFilter from '../../../assets/images/CustomerManagement/columnFilter.svg'
import valueFilter from '../../../assets/images/CustomerManagement/valueFilter.svg'
import '../../../assets/css/dashboard.scss'
import '../../../assets/css/customermanagement.scss'
import 'react-datepicker/dist/react-datepicker.css';
import SbCancelBtn, { SbAddBtn, SbFilterBtn } from '../../Buttons/Buttons';
import Select from 'react-select';
import Download from '../../MainSection/Download/Download';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { loadAssignedModulesDropdownData, loadCompanyDropdownData, loadDesignationData, loadSettingsDynamicDashboard, loadSettingsDynamicDashboardCategoryDropdown, loadSettingsSingleDynamicDashboardData, loadSingleDesignationData, postDesignationDatas, postDynamicDashboardDatas } from '../../../redux/action';
import * as HeaderAuthentication from '../../HeaderAuthentication'
import { ADDED_BY_ID } from '../../../Constants';
import DynamicDashboardsTable from './DynamicDashboardsTable';
import DesignationTable from '../Designation/DesignationTable';
import AddDynamicDashboards from './AddDynamicDashboards';
import DynamicDashboardColumnFilterModal from './DynamicDashboardColumnFilterModal';
import SbDropdownButton from '../../Buttons/SbDropdownButton';
import DynamicDashboardBulkUploadModal from './DynamicDashboardBulkUploadModal';

const enablingOptions = [
    { value: 65, label: "Active" },
    { value: 66, label: "Inactive" }
]

const DynamicDashboards = () => {

    let dispatch = useDispatch();
    const { id: userRefId } = useParams();

    const { getDynamicDashboardData, totalDataCount, getDynamicDashboardCategoryDropdownData, getCompanyDropdown, getSingleDynamicDashboardData, assignedModulesDropdown } = useSelector((state) => state.data);
    // console.log(getSingleDynamicDashboardData, 'getSingleDynamicDashboardData')
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [showFilterMenu, setShowFilterMenu] = useState(false);
    const [showColumnFilterModal, setShowColumnFilterModal] = useState(false);
    const [showValueFilterModal, setShowValueFilterModal] = useState(false);
    const [showCustomerViewDetails, setShowCustomerViewDetails] = useState(false);
    const [businessUnitModal, setBusinessUnitModal] = useState(false);
    const [branchPlantModal, setBranchPlantModal] = useState(false);
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [selectedColumns, setSelectedColumns] = useState([
        "COMPANY NAME", "DASHBOARD NAME", "CATEGORY", "SECURED LINK", "PUBLIC LINK", "DESCRIPTION", "STATUS", "ACTION"
    ]);
    const [dashboardId, setDashboardId] = useState("");
    const [selectedStatusID, setSelectedStatusID] = useState(null);
    const [selectedClientID, setSelectedClientID] = useState(null);
    const [showBulkUploadModal, setShowBulkUploadModal] = useState(false);
    const [dataLoading, setDataLoading] = useState(false);

    const toggleFilterMenu = () => {
        setShowFilterMenu(!showFilterMenu);
    };

    const handleFromDateChange = (date) => {
        setFromDate(date);
    };

    const handleToDateChange = (date) => {
        setToDate(date);
    };
    const handleOpenModal = (dashboardLibId) => {
        setIsModalOpen(true);
        if (dashboardLibId) {
            dispatch(loadSettingsSingleDynamicDashboardData(setDataLoading, dashboardLibId));
            setDashboardId(dashboardLibId);
        } else {
            setDashboardId("");
        }
    };

    const handleCloseModal = () => {
        setDashboardId("");
        dispatch(loadSettingsSingleDynamicDashboardData(setDataLoading, null));
        setIsModalOpen(false);
    };

    const handleOpenBulkUploadModal = () => {
        setShowBulkUploadModal(true);
    };
    const handleCloseBulkUploadModal = () => {
        setShowBulkUploadModal(false);
    };

    const handleOpenColumnFilterModal = () => {
        setShowFilterMenu(false);
        setShowColumnFilterModal(true);
    };

    const handleCloseColumnFilterModal = () => {
        setShowColumnFilterModal(false);
    };
    const handleOpenValueFilterModal = () => {
        setShowFilterMenu(false);
        setShowValueFilterModal(true);
    };

    const handleCloseValueFilterModal = () => {
        setShowValueFilterModal(false);
    };

    const handleViewDetails = () => {
        setShowCustomerViewDetails(!showCustomerViewDetails);
    }

    useEffect(() => {
        if (userRefId) {
            dispatch(loadSettingsSingleDynamicDashboardData(setDataLoading, userRefId));
        } else {
            fetchDynamicDashboards();
        }
    }, [userRefId]);

    const fetchDynamicDashboards = (statusID = null, clientID = null) => {
        dispatch(loadSettingsDynamicDashboard(setLoading, rowsPerPage, page + 1, statusID, clientID));
    }

    // useEffect(() => {
    //     fetchDynamicDashboards();
    // }, [page, rowsPerPage]);

    useEffect(() => {
        fetchDynamicDashboards(selectedStatusID, selectedClientID);
    }, [page, rowsPerPage, selectedStatusID, selectedClientID]);

    useEffect(() => {
        dispatch(loadSettingsDynamicDashboardCategoryDropdown());
        dispatch(loadCompanyDropdownData());
        dispatch(loadAssignedModulesDropdownData());
    }, [])

    const handleColumnSelectionChange = (updatedSelectedColumns) => {
        setSelectedColumns(updatedSelectedColumns); // Update the selected columns
    };

    const handleStatusSelection = (selectedOption) => {
        if (selectedOption) {
            const statusID = selectedOption.value;  // Extract StatusID (assuming 'value' is the StatusID)
            setSelectedStatusID(statusID);  // Store StatusID in state
            fetchDynamicDashboards(statusID);  // Call API with both StatusID and current RoleID
        }
    };

    const handleClientSelection = (selectedOption) => {
        const clientID = selectedOption ? selectedOption.value : null;
        setSelectedClientID(clientID);
        fetchDynamicDashboards(selectedStatusID, clientID); // Pass both status and client ID
    };

    const handleStatusChange = (customer, statusLabel) => {
        const statusID = statusLabel === "Active" ? 65 : 66; // 12 for Active, 13 for Inactive

        console.log(customer, 'customer')
        const data = {
            CompanyID: customer.CompanyID || null,
            DashboardLibraryID: customer.DashboardLibraryID || null,
            DashboardLibraryName: customer.DashboardLibraryName || "",
            DashboardCategoryID: customer.DashboardCategoryID || null,
            SecuredLink: customer.SecuredLink || "",
            PublicLink: customer.PublicLink || "",
            Description: customer.Description || "",
            FileName: customer.FileName || "",
            AddedByID: ADDED_BY_ID,
            StatusID: statusID || null,
            File: customer.File,
            IsFileUpdated: false,
        }
        let requestOption = {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(data),
        };

        // Dispatch the action to update the department status
        dispatch(postDynamicDashboardDatas(requestOption, handleCloseModal, fetchDynamicDashboards, customer.DashboardLibraryID));
        console.log(data, 'data'); // For debugging purposes
    };

    const navigate = useNavigate();
    const handleBack = () => {
        navigate(-1);
    };

    const handleClearFilters = () => {
        setSelectedStatusID(null);
        setSelectedClientID(null);
        fetchDynamicDashboards();
    }

    return (
        <div className="customer-management-container">
            <Main>
                <div className='components-download-container'>
                    <Download
                        showBackButton={true}
                        moduleName="Settings / Dashboards"
                        onBackClick={handleBack}
                    />
                </div>
                <div className='customermanagement-content-container'>
                    <div className="customermanagement-content">
                        <Row className='customermanagement-btns-container'>
                            <Col md={3} className='customermanagement-backbtn-div'>
                                {/* <img src={backbtn} alt="" /> */}
                                <span>Dashboards</span>
                            </Col>
                            <Col md={9} className='customermanagement-search-filter'>
                                <div className='customermanagement-header-btns filter-btn'>
                                    {/* <SbFilterBtn btnName="Filters" onClickEffect={toggleFilterMenu} /> */}
                                    {showFilterMenu && (
                                        <Dropdown.Menu show className='filter-dropdown-options'>
                                            <Dropdown.Item onClick={handleOpenColumnFilterModal}>
                                                <img src={columnFilter} alt="" />&nbsp;&nbsp;
                                                Column Filter
                                            </Dropdown.Item>
                                            {/* <Dropdown.Item onClick={handleOpenValueFilterModal}>
                                                <img src={valueFilter} alt="" />&nbsp;&nbsp;
                                                Value Filter
                                            </Dropdown.Item> */}
                                        </Dropdown.Menu>
                                    )}
                                </div>
                                <Col md={3}>
                                    <Select
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        placeholder="Search Client"
                                        options={getCompanyDropdown}
                                        style={{ width: "100%" }}
                                        value={selectedClientID ? getCompanyDropdown.find(client => client.value === selectedClientID) : null}
                                        onChange={(selectedOption) => handleClientSelection(selectedOption)}
                                    />
                                </Col>
                                <Col md={3}>
                                    <Select
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        placeholder="Search Status"
                                        options={enablingOptions}
                                        style={{ width: "100%" }}
                                        value={selectedStatusID ? enablingOptions.find(status => status.value === selectedStatusID) : null}
                                        onChange={(selectedOption) => handleStatusSelection(selectedOption)}
                                    />
                                </Col>
                                <SbCancelBtn btnName="Clear" onClickEffect={handleClearFilters} />
                                {/* <SbAddBtn btnName="Add" onClickEffect={() => { handleOpenModal("") }} /> */}
                                <SbDropdownButton
                                    btnName="Add"
                                    openAddModal={() => { handleOpenModal("") }}
                                    addBulkModel={handleOpenBulkUploadModal}
                                />
                            </Col>
                        </Row>
                        <div className='customermanagement-table-div'>
                            <DynamicDashboardsTable
                                handleOpenModal={handleOpenModal}
                                handleViewDetails={handleViewDetails}
                                getDynamicDashboardData={getDynamicDashboardData}
                                loading={loading}
                                page={page}
                                setPage={setPage}
                                rowsPerPage={rowsPerPage}
                                setRowsPerPage={setRowsPerPage}
                                totalDataCount={totalDataCount}
                                selectedColumns={selectedColumns}
                                handleStatusChange={handleStatusChange}
                                getSingleDynamicDashboardData={getSingleDynamicDashboardData}
                                userRefId={userRefId}
                            />
                        </div>
                    </div>
                </div>
            </Main>
            {
                isModalOpen && <AddDynamicDashboards
                    open={isModalOpen}
                    handleCloseModal={handleCloseModal}
                    getDynamicDashboardCategoryDropdownData={getDynamicDashboardCategoryDropdownData}
                    getCompanyDropdown={getCompanyDropdown}
                    fetchDynamicDashboards={fetchDynamicDashboards}
                    dashboardId={dashboardId}
                    getSingleDynamicDashboardData={getSingleDynamicDashboardData}
                    enablingOptions={enablingOptions}
                    assignedModulesDropdown={assignedModulesDropdown}
                    dataLoading={dataLoading}
                />
            }
            {
                showBulkUploadModal && <DynamicDashboardBulkUploadModal
                    showBulkUploadModal={showBulkUploadModal}
                    handleCloseBulkUploadModal={handleCloseBulkUploadModal}
                    fetchDynamicDashboards={fetchDynamicDashboards}
                />
            }
            {showColumnFilterModal && (
                <DynamicDashboardColumnFilterModal
                    showColumnFilterModal={showColumnFilterModal}
                    handleCloseColumnFilterModal={handleCloseColumnFilterModal}
                    selectedColumns={selectedColumns}
                    handleSaveColumns={handleColumnSelectionChange}
                />
            )}
            {/* {showValueFilterModal && (
                <CustomerValueFilterModal
                    showValueFilterModal={showValueFilterModal}
                    handleCloseValueFilterModal={handleCloseValueFilterModal}
                />
            )}
            {showCustomerViewDetails && (
                <CustomerViewDetails
                    showCustomerViewDetails={showCustomerViewDetails}
                    handleCloseViewDetails={handleCloseViewDetails}
                />
            )} */}
        </div >
    );
};

export default DynamicDashboards;